var address = {};
module['exports'] = address;
address.building_number = require("./building_number");
address.city = require("./city");
address.county = require("./county");
address.default_country = require("./default_country");
address.postcode = require("./postcode");
address.secondary_address = require("./secondary_address");
address.state = require("./state");
address.state_abbr = require("./state_abbr");
address.street_address = require("./street_address");
address.street_name = require("./street_name");
address.street_suffix = require("./street_suffix");
address.streets = require("./streets");
